/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const WalletTransactionStatus = {
  Pending: "pending",
  Completed: "completed",
  Canceled: "canceled",
  Failed: "failed",
} as const;
export type WalletTransactionStatus = ClosedEnum<
  typeof WalletTransactionStatus
>;

/** @internal */
export const WalletTransactionStatus$inboundSchema: z.ZodNativeEnum<
  typeof WalletTransactionStatus
> = z.nativeEnum(WalletTransactionStatus);
/** @internal */
export const WalletTransactionStatus$outboundSchema: z.ZodNativeEnum<
  typeof WalletTransactionStatus
> = WalletTransactionStatus$inboundSchema;
